<template>
  <RF-Dialog v-if="statusGeral !== null"
    :cpntLargura='"560px"'
    :cpntStatus="statusGeral"
    :cpntOnFecharDialog='() => { onCloseForm(false) }'>
    <template slot='titulo'>      
      <template v-if='(registro.length === 1 && registro[0] === 0)'>
        <i aria-hidden="true" class="fa fa-angle-double-right"></i>
        Nova da categoria de Serviço
      </template>
      <template v-else-if='(registro.length === 1 && registro[0] >= 1)'>
        <i aria-hidden="true" class="fa fa-angle-double-right"></i>
        Edição da categoria de Serviço {{ registro[0] }}
      </template>
      <template v-else>
        <i aria-hidden="true" class="fa fa-angle-double-right"></i>
        <span style='color: red;'>{{ registro }}erro ao identificar registro</span>
      </template>          
    </template>

    <template slot='conteudo'>
      <div class='rf-prod-forms' style="padding-top: 15px; width: 540px;">
        <div v-if='Object.keys(formulario).length >= 1'>
          <RF-Formulario :data-time='time'
            :cpntTime='time'
            :cpntId='formulario.id' 
            :cpntStatus='""'
            :cpntField='formulario.field'
            :cpntUltAlt='formulario.ult_alt'
            :cpntButtons='formulario.buttons'

            :ref='formulario.id'
          ></RF-Formulario>
        </div>
      </div>
    </template>
  </RF-Dialog>

  <!-- <div class='rf-web-mask-pagina'>
    <div>
      <div>
        <template v-if='statusGeral === "" || registro.length >= 1'>
          <div class="rf-web-mask-titulo" style='width: 560px;'>
            <div class="rf-web-mask-fechar">
              <RF-Button 
                :cpntId='"rf-web-mask-fechar"'
                :cpntStatus='""' 
                :cpntTipo='"fechar"'
                :cpntClass='[ "btn", "btn-danger" ]'

                @onClickButton='onCloseForm(false)'
              ></RF-Button>
            </div>

            <template v-if='(registro.length === 1 && registro[0] === 0)'>
              <i aria-hidden="true" class="fa fa-angle-double-right"></i>
              Nova da categoria de Serviço
            </template>
            <template v-else-if='(registro.length === 1 && registro[0] >= 1)'>
              <i aria-hidden="true" class="fa fa-angle-double-right"></i>
              Edição da categoria de Serviço {{ registro[0] }}
            </template>
            <template v-else>
              <i aria-hidden="true" class="fa fa-angle-double-right"></i>
              <span style='color: red;'>{{ registro }}erro ao identificar registro</span>
            </template>          
          </div>
        </template>

        <div class="rf-web-mask-conteudo" style='width: 560px;'>
          <div v-if='statusGeral !== ""' style='width: 100%; text-align: center;'>
            <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
          </div>

          <div v-else-if='statusGeral === ""' class='rf-prod-forms'>
            <div v-if='Object.keys(formulario).length >= 1'>
              <RF-Formulario :data-time='time'
                :cpntTime='time'
                :cpntId='formulario.id' 
                :cpntStatus='""'
                :cpntField='formulario.field'
                :cpntUltAlt='formulario.ult_alt'
                :cpntButtons='formulario.buttons'

                :ref='formulario.id'
              ></RF-Formulario>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</template>

<style scoped>
  .rf-prod-forms {
  }
    .rf-prod-forms > div {
      width: 515px;
      float: left;
    }
</style>

<script>
  export default {
    props: {
      cpntId: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntNomeDig: {
        required: false,
        type: [ String, Number ],
        default: function () {
          return ''
        }
      },
      cpntAbrirEstado: {
        required: false,
        type: String,
        default: function () {
          return this.$store.state.licenca.uf
        }
      }
    },
    data: function () {
      return {
        time: new Date().getTime(),
        registro: [],
        statusGeral: '',
        formulario: {}
      }
    },
    mounted: function () {
      if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(true, [ 15 ], null, [ 25 ], null, [ 536 ], null, true) === true) {
        this.iniciarVerificacao()
      } else {
        this.onCloseForm(false)
      }
    },
    methods: {
      iniciarVerificacao: function () {
        var self = this

        // SETA O STATUS GERAL
        self.statusGeral = 'carregando'

        // RESETA OS REGISTROS DA TELA
        self.registro = []

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // FAZ A VERIFICAÇÃO DO REGISTRO QUE ESTA SENDO TRABALHADO
        self.$store.state.CHECK_REGISTRO_FORM(self.cpntId, self.$route.params.id, function (reg, status) {
          // SETA O STATUS GERAL
          self.statusGeral = status

          // VERIFICA SE DEU ALGUM ERRO
          if (status === '') {
            // SETA OS REGISTROS RECEBIDOS
            self.registro = reg

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA INICIAR O FORMULARIO
            self.iniciaFormulario()
          }
        })
      },
      iniciaFormulario: function () {
        var self = this

        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        self.formulario = {
          status: 'carregando',
          id: 'form-ser-cat',
          focus: '',
          field: {}
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        self.formulario.field = {
          nome: {
            tipo: 'input',
            tamanho: 1,
            nome: 'Nome',
            apiEnv: 'nome',
            apiRec: 'nome',
            value: self.cpntId === 0 ? self.cpntNomeDig : '',
            onChange: function (value, id) {
              self.onChangeValue(value, id)
            }
          }
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // CRIA AS CHAVES PADROES DE TODOS OS COMPONENTS
        self.$store.state.FUN_CREATE_KEY_FIELDS(self.formulario.field, function (fields) {
          // SETA OS CAMPOS RECEBIDOS
          self.formulario.field = fields

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // CHAMA A FUNÇÃO PARA BUSCAR OS DADOS QUE SERÁ EDITADO
          self.buscarRegistro()
        })
      },
      finalizaFormulario: function () {
        var self = this

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // CRIA OS BOTTUNS DO FORMULARIO
        self.$store.state.FUN_CREATE_BUTTON_FORM(self.formulario.id, self.registro, self.cpntId, {
          env: function () {
            self.onEnviarForm('env')
          },
          insMais: function () {
            self.onEnviarForm('insMais')
          },
          can: function () {
            self.onCloseForm(false)
          }
        }, function (buttons) {
          // CRIA OS BUTTONS DO FORMULARIO
          self.formulario.buttons = buttons

          // SETA O STATUS
          self.formulario.status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // SETA O CAMPO QUE RECEBE O FOCUS
          self.$store.state.FUN_FOCUS_CAMPO_IN_FORM(self, 'formulario', 'nome', false)
        })
      },
      onChangeValue: function (value, campo) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ATUALIZADO
        var index = campo.substring((this.formulario.id.length + 1), campo.length)

        // SETA O VALORE RECEBIDO
        this.formulario.field[index].value = value

        // LIMPA AS MENSAGENS DE VALIDAÇÃO
        this.formulario.field[index].mensagem = ''
        this.formulario.field[index].mensagemTipo = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      buscarRegistro: function () {
        var self = this

        if (self.registro.length >= 1 && self.registro[0] !== 0) {
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, nome: null, last_at: null, last_user: { j: { usuario: null } }, status: null }, where: { f: 'id', o: 'in', v: self.registro.join() } }

          self.$store.state.comunicaAPI('/servico/categoria/get/', 'GET', queryGet, function (apiSuccess) {
            if (apiSuccess.data.length >= 1) {
              self.$store.state.FUN_API_RET_SET_VALUE(self.formulario, apiSuccess.data[0], function (form) {
                // SETA OS CAMPOS RECEBIDOS
                self.formulario = form

                // CHAMA A FUNÇÃO PARA FINALIZAR O FORMULARIO
                self.finalizaFormulario()
              }, [ 'last_at_ptbr', 'last_user', 'last_user_usuario' ])
            } else {
              // APRESENTA A MENSAGEM RETORNADA DA API
              self.$store.state.msgWarn('WEB [409]: Serviço não localizado.', 'warning')

              // CHAMA A FUNÇÃO PARA FECHAR O FORMULARIO
              self.onCloseForm(false)
            }
          }, function (apiError) {
            // SETA O STATUS PARA O FORMULARIO
            self.statusGeral = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          })
        } else {
          self.finalizaFormulario()
        }
      },
      onCloseForm: function (comunicadoAPi, id = null) {
        if (this.cpntId === null) {
          // EMITE EVENTO PARA ATUALIZAR A TABELA
          this.$emit('RefreshTabela')

          // SAI DA ROTA DE FORMULARIO
          this.$router.push({ name: 'servico_config_categoria' })
        } else {
          this.$emit('onCloseForm', comunicadoAPi, id)
        }
      },
      onEnviarForm: function (button) {
        var self = this

        // REMOVE O STATUS DE CARREGANDO PARA O BUTTON
        self.formulario.buttons[button].status = 'carregando'

        // CRIA O FORMULARIO PARA ATUALIZAR
        self.$store.state.FUN_CREATE_FORM_API_FORMULARIO(self.formulario.field, {}, function (formData) {
          // VERIFICA SE DEVE INFORMAR O J_ID
          if (self.registro.length === 1 && self.registro[0] >= 1 || self.registro.length >= 2) {
            formData['j_id'] = JSON.stringify(self.registro)
          }

          self.$store.state.comunicaAPI('/servico/categoria', (formData.hasOwnProperty('j_id') ? 'PUT' : 'POST'), formData, function (apiSuccess) {
            // REMOVE O STATUS DE CARREGANDO PARA O BUTTON
            self.formulario.buttons[button].status = ''

            // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
            self.formulario.time = new Date().getTime()

            if (self.cpntId !== null) {
              // FECHA O FORMULARIO
              self.onCloseForm(true, (apiSuccess.hasOwnProperty('ref') && apiSuccess.ref.hasOwnProperty('id')) ? apiSuccess.ref.id : self.registro[0])
            } else {
              // CHAMA A FUNÇÃO PARA MOSTAR A MENSAGEM RECEBIDA DA API
              self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
                // FECHA O FORMULARIO
                self.onCloseForm(true, (apiSuccess.hasOwnProperty('ref') && apiSuccess.ref.hasOwnProperty('id')) ? apiSuccess.ref.id : self.registro[0])
              })
            }
          }, function (apiError) {
            // SETA O STATUS PARA O FORMULARIO
            self.formulario.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          }, function (apiValid, apiStatus) {
            self.$store.state.FUN_API_RET_VALIDA(self, 'formulario', apiValid, apiStatus, self.formulario.field, true, function (form) {
              // SETA OS CAMPOS COM OS ERROS
              self.formulario.field = form

              // REMOVE O STATUS DE CARREGANDO PARA O BUTTON
              self.formulario.buttons[button].status = ''

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            })
          })
        })
      }
    },
    watch: {
      '$route': function () {
        this.iniciarVerificacao()
      },
      'cpntId': function () {
        this.iniciarVerificacao()
      }
    }
  }
</script>
